import React from 'react';

import { Clickable, Hoverable, Wrapper as ButtonWrapper, withBlockTypeConfigProps, withBlockTypeConfigPropsV2, withModalVisibility } from '../common/Button.jsx';
import Defaults from '../layout/Defaults.jsx';
import { default as Image } from '../common/Image.jsx';
import { Component as InquirePopup } from './InquirePopup.jsx';
import { default as InventoryHelper } from '../common/Inventory.jsx';
import Layout from '../common/Layout.jsx';
import Name from '../common/Name.jsx';
import { Component as OfferPopup } from './OfferPopup.jsx';
import { ShareModal, VirtualInstallModal } from '../common/Popup.jsx';
import { Component as PurchasePopup } from './PurchasePopup.jsx';
import Utilities from '../common/Utilities.jsx';

// #region INQUIRE BUTTON (-- DEPRECATED Use `InventoryCTAButton` --)

function _InquireButtonComponent(props) {
    const config = props.config || {};
    return (
        <React.Fragment>
            <div style={props.style}>
                <props.buttonComponent
                    className="btn btn--outl btn--prim btn--md form__btn btn--whitelabel btn--inquire"
                    hoverProps={props.hoverProps}
                    id="inquire-btn"
                    style={props.buttonStyle}
                    type="button"
                    onClick={props.onButtonClick}>
                    {props.display || Defaults.Block[Name.Block.Inventory.Button.InquireV1]}
                </props.buttonComponent>
            </div>
            {
                props.modalVisible &&
                <InquirePopup
                    builder={props.builder}
                    config={config}
                    inventory={props.data}
                    sub={config.subdomain}
                    onClose={props.onModalClose} />
            }
        </React.Fragment>
    );
}
const InquireButtonComponent = withBlockTypeConfigProps(withModalVisibility(_InquireButtonComponent));
const InquireButton = { Component: InquireButtonComponent };

// #endregion INQUIRE BUTTON

// #region OFFER BUTTON (-- DEPRECATED Use `InventoryCTAButton` --)

function _OfferButtonComponent(props) {
    const config = props.config || {};
    // const inventory = (props.data && props.data.inventory) || {};
    const inventory = props.data || {};
    let renderButton = props.builder;
    if (!props.builder) {
        renderButton = inventory.available && config.canReceiveOffers
    }
    return (
        <React.Fragment>
            {
                renderButton &&
                <div style={props.style}>
                    <props.buttonComponent
                        className="btn btn--outl btn--prim btn--md form__btn btn--whitelabel btn--offer"
                        hoverProps={props.hoverProps}
                        id="detail-offer-btn"
                        style={props.buttonStyle}
                        type="button"
                        onClick={props.onButtonClick}>
                        {props.display || Defaults.Block[Name.Block.Inventory.Button.OfferV1]}
                    </props.buttonComponent>
                </div>
            }
            {
                props.modalVisible &&
                <OfferPopup
                    builder={props.builder}
                    config={config}
                    inventory={inventory}
                    localization={config.localization}
                    sub={config.subdomain}
                    onClose={props.onModalClose} />
            }
        </React.Fragment>
    );
}
const OfferButtonComponent = withBlockTypeConfigProps(withModalVisibility(_OfferButtonComponent));
const OfferButton = { Component: OfferButtonComponent };

// #endregion OFFER BUTTON

// #region PURCHASE BUTTON (-- DEPRECATED Use `InventoryCTAButton` --)

function _PurchaseButtonComponent(props) {
    const config = props.config || {};
    // const inventory = (props.data && props.data.inventory) || {};
    const inventory = props.data || {};
    let renderButton = props.builder;
    if (!props.builder) {
        renderButton = inventory.available && config.isStripeConnected
    }
    return (
        <React.Fragment>
            {
                renderButton &&
                <div style={props.style}>
                    <props.buttonComponent
                        className="btn btn--outl btn--prim btn--md form__btn btn--whitelabel btn--purchase"
                        hoverProps={props.hoverProps}
                        id="detail-purchase-btn"
                        style={props.buttonStyle}
                        type="button"
                        onClick={props.onButtonClick}>
                        {props.display || Defaults.Block[Name.Block.Inventory.Button.PurchaseV1]}
                    </props.buttonComponent>
                </div>
            }
            {
                props.modalVisible &&
                <PurchasePopup
                    builder={props.builder}
                    config={config}
                    inventory={inventory}
                    querySub={props.querySub}
                    sub={config.subdomain}
                    onClose={props.onModalClose} />
            }
        </React.Fragment>
    );
}
const PurchaseButtonComponent = withBlockTypeConfigProps(withModalVisibility(_PurchaseButtonComponent));
const PurchaseButton = { Component: PurchaseButtonComponent };

// #endregion PURCHASE BUTTON

// #region INVENTORY CTA BUTTON

const ButtonType = {
    Inquire: 'inquire',
    Offer: 'offer',
    Purchase: 'purchase',
    
    fromBlockConfig: (blockConfig) => blockConfig.config && blockConfig.config.block && blockConfig.config && blockConfig.config.block.buttonType
};
function _InventoryCTAButtonComponent(props) {
    const config = props.config || {};
    const inventory = props.data || {};
    let defaultMessage;
    let renderButton = true;
    let ModalComponent = InquirePopup;
    if (!props.builder) {
        if (props.blockConfig && props.blockConfig.block) {
            switch (props.blockConfig.block.buttonType) {
                case ButtonType.Inquire:
                    defaultMessage = config.defaultInquireMessage
                    if (props.blockConfig.block.hideOnUnavailable) {
                        renderButton = inventory.canInquire;
                    }
                    break;
                case ButtonType.Offer:
                    ModalComponent = OfferPopup;
                    renderButton = inventory.available && config.canReceiveOffers
                    break;
                case ButtonType.Purchase:
                    ModalComponent = PurchasePopup;
                    renderButton = inventory.available && config.isStripeConnected
                    break;
            }
            const edition = InventoryHelper.edition(inventory) || {};
            if (props.blockConfig.block.hideOnHold && edition.isOnHold) {
                renderButton = false;
            }
        }
    }
    if (!renderButton) {
        return null;
    }
    let className = 'btn btn--whitelabel btn--cta btn--custom2 richText';
    if (props.className) {
        className += ` ${props.className}`
    }
    return (
        <React.Fragment>
            <ButtonWrapper {...props}>
                <props.buttonComponent
                    className={className}
                    design={props.design}
                    hoverProps={props.hoverProps}
                    style={props.style}
                    type="button"
                    onClick={props.onButtonClick} />
            </ButtonWrapper>
            {
                props.modalVisible &&
                <ModalComponent
                    builder={props.builder}
                    config={config}
                    defaultMessage={defaultMessage}
                    inventory={inventory}
                    localization={config.localization}
                    querySub={props.querySub}
                    sub={config.subdomain}
                    onClose={props.onModalClose} />
            }
        </React.Fragment>
    );
}
const InventoryCTAButtonV1Component = withBlockTypeConfigPropsV2(withModalVisibility(_InventoryCTAButtonComponent));
const InventoryCTAButtonV2Component = withBlockTypeConfigPropsV2(withModalVisibility(_InventoryCTAButtonComponent), undefined, true);
const InventoryCTAButton = { V1: InventoryCTAButtonV1Component, V2: InventoryCTAButtonV2Component };

// #endregion INVENTORY CTA BUTTON

// #region CONTROLS

function _InventoryControlsComponent(props) {
    const config = props.config || {};
    const inventory = (props.data && props.data.inventory) || {};
    const edition = InventoryHelper.edition(inventory) || {};
    const images = inventory.images || [];
    const [shareModalVisible, setShareModalVisible] = React.useState(false);
    const [virtualInstallModalVisible, setVirtualInstallModalVisible] = React.useState(false);

    const shareButtonStyle = {};
    Utilities.copyObject(props.buttonStyle, shareButtonStyle);
    let alignment, contentShare, contentVirtualInstall;
    let className = 'artwork__controls';
    let includeShare = true;
    let includeVirtualInstall = false;
    const isFirstImageGif = images.length > 0 && images[0].extension === 'gif';
    if (props.blockConfig && props.blockConfig.block) {
        includeShare = props.blockConfig.block.includeShare;
        switch (`${inventory.type}`) {
            case InventoryHelper.Type.Artwork:
                includeVirtualInstall = props.blockConfig.block.includeVirtualInstall;

                if (includeVirtualInstall && props.blockConfig.block.depthThreshold) {
                    const maxDepth = parseFloat(props.blockConfig.block.depthThreshold);
                    if (!isNaN(maxDepth) && edition.dimensions && edition.dimensions.depth > maxDepth) {
                        includeVirtualInstall = false;
                    }
                }
                break;
        }
        if (includeShare) {
            if (props.blockConfig.block.displayShare && props.blockConfig.block.displayShare.length > 0) {
                contentShare = `<span>${props.blockConfig.block.displayShare}</span>`;
            } else if (props.blockConfig.block.designShare && props.blockConfig.block.designShare.length > 0) {
                className += ' richText';
                contentShare = Layout.editorTextInternals(props.blockConfig.block.designShare);
            }
        }
        if (includeVirtualInstall && !isFirstImageGif) {
            if (props.blockConfig.block.displayVirtualInstall && props.blockConfig.block.displayVirtualInstall.length > 0) {
                contentVirtualInstall = `<span>${props.blockConfig.block.displayVirtualInstall}</span>`;
            } else if (props.blockConfig.block.designVirtualInstall && props.blockConfig.block.designVirtualInstall.length > 0) {
                contentVirtualInstall = Layout.editorTextInternals(props.blockConfig.block.designVirtualInstall);
                if (className.indexOf('richText') < 0) {
                    className += ' richText';
                }
            }
        }
        let lineSpacing;
        if (includeShare && includeVirtualInstall && props.blockConfig.block.lineSpacing && props.blockConfig.block.lineSpacing.value && props.blockConfig.block.lineSpacing.unit) {
            lineSpacing = `${props.blockConfig.block.lineSpacing.value}${props.blockConfig.block.lineSpacing.unit}`;
        }
        alignment = props.blockConfig.block.alignment;
        if (props.style) {
            props.style.textAlign = alignment;
        }
        switch (props.blockConfig.block.direction) {
            case 'column':
                if (props.style) {
                    props.style.flexDirection = 'column';
                }
                if (lineSpacing) {
                    shareButtonStyle.marginBottom = lineSpacing;
                }
                break;
            default:
                if (props.style) {
                    props.style.flexDirection = 'row';
                }
                if (lineSpacing) {
                    shareButtonStyle.marginRight = lineSpacing;
                }
                break;
        }
    }
    let ButtonComponent = Clickable;
    if (props.hoverProps != undefined) {
        ButtonComponent = Hoverable;
    }
    if (!contentShare) {
        contentShare = '<span>share</span>';
    }
    let index = contentShare.indexOf('>');
    if (index >= 0) {
        contentShare = contentShare.substring(0, index + 1) + `<span class="i i-share"></span>&nbsp;` + contentShare.substring(index + 1);
    }
    if (!contentVirtualInstall) {
        contentVirtualInstall = '<span>virtual install</span>';
    }
    index = contentVirtualInstall.indexOf('>');
    if (index >= 0) {
        contentVirtualInstall = contentVirtualInstall.substring(0, index + 1) + `<span class="i i-collector"></span>&nbsp;` + contentVirtualInstall.substring(index + 1);
    }
    let hoverPropsShare, hoverPropsVirtualInstall;
    if (props.hoverProps && props.hoverProps.color) {
        hoverPropsShare = { design: Utilities.injectStyleIntoString(contentShare, `color:${props.hoverProps.color};`)}
        hoverPropsVirtualInstall = { design: Utilities.injectStyleIntoString(contentVirtualInstall, `color:${props.hoverProps.color};`)}
    }
    const isRowDirection = props.style && props.style.flexDirection != 'column';
    return (
        <React.Fragment>
            <div className={className} style={props.style}>
                {
                    isRowDirection &&
                    alignment != 'left' &&
                    <span style={{ flex: 1 }} />
                }
                {
                    includeShare &&
                    <ButtonComponent
                        contentClassName="p"
                        design={contentShare}
                        hoverProps={hoverPropsShare}
                        style={shareButtonStyle}
                        onClick={() => setShareModalVisible(true)} />
                }
                {
                    includeVirtualInstall && !isFirstImageGif &&
                    <ButtonComponent
                        contentClassName="p"
                        design={contentVirtualInstall}
                        hoverProps={hoverPropsVirtualInstall}
                        style={props.buttonStyle}
                        onClick={() => setVirtualInstallModalVisible(true)} />
                }
                {
                    isRowDirection &&
                    alignment != 'right' &&
                    <span style={{ flex: 1 }} />
                }
            </div>
            {
                shareModalVisible &&
                <ShareModal
                    builder={props.builder}
                    inventory={inventory}
                    pageConfig={props.data}
                    sub={config.subdomain}
                    onClose={() => setShareModalVisible(false)} />
            }
            {
                virtualInstallModalVisible &&
                <VirtualInstallModal
                    data={{ Title: inventory.title, Dimensions: edition.dimensions }}
                    sub={config.subdomain}
                    image={Image.url(images[0], undefined, 640)}
                    onClose={() => setVirtualInstallModalVisible(false)} />
            }
        </React.Fragment>
    );
}
const InventoryControlsComponent =
    withBlockTypeConfigProps(
        _InventoryControlsComponent,
        ['includeShare', 'designShare', 'displayShare', 'includeVirtualInstall', 'designVirtualInstall', 'displayVirtualInstall', 'alignment', 'direction', 'lineSpacing'],
        false
    );
const InventoryControls = { Component: InventoryControlsComponent };

// #endregion CONTROLS

export {
    ButtonType,
    InventoryControls,
    InventoryCTAButton,

    // DEPRECATED
    InquireButton,
    OfferButton,
    PurchaseButton
};